<template>
  <unicom-layout-cartao semFiltro :comPadding="false">
    <div
      style="
        padding: 32px;
        padding-bottom: 20px;
        height: 454px;
        max-height: 454px;
      "
    >
      <unicom-linha class="pb-4">
        <unicom-coluna sm="12" md="auto">
          <div class="titulo negrito cor-fonte fonte-primaria">
            Relatório de erros
          </div>
        </unicom-coluna>
        <unicom-coluna
          sm="12"
          md="auto"
          class="ml-auto"
          :class="$breakpoint.smAndDown ? 'mt-2' : ''"
          v-if="mostrarBotaoExportar"
        >
          <unicom-botao
            @click="$emit('exportar-relatorio')"
            contornado
            :largura="220"
            nomeIcone="upload-cloud"
            :bloco="$breakpoint.smAndDown"
          >
            Exportar relatório
          </unicom-botao>
        </unicom-coluna>
      </unicom-linha>
      <div class="body-tabela-erro">
        <unicom-tabela
          :checkCorpoProp="selecionados"
          :mostrarCheckTodos="false"
          :mostrarCheck="mostrarCheck"
          :exibirQtItensPagina="qtPaginas > 0"
          :svgMensagemVazia="ArquivoSvg"
          :tamanhoSvg="50"
          mensagemVazia="Nenhum erro encontrado nesse arquivo"
          mostrarNovoBlocoVazio
          alturaMinimaBody="295px"
          overflowBody
          :alturaBody="275"
          :exibirTodosHeaders="false"
          :icones="[]"
          :itensPorPagina="['5', '10', '15', '20']"
          itemSelecionadoProp="10"
          :carregamento="loadingTabela"
          :pagina="pagina"
          :qtPaginas="qtPaginas"
          :qtResultados="qtResultados"
          :rows="rows"
          :cabecalho="cabecalho"
          novaLinha
          alinharFooter="end"
          :exibirFooter="rows.length > 0"
          :textosNovaLinha="arrNovaLinha"
          textoExibindo="erros encontrados"
          @check="marcarCheck"
          @troca-pagina="trocarPagina"
        />
      </div>
    </div>
  </unicom-layout-cartao>
</template>

<script>
import TabelaErroMixin from "./TabelaErroMixin";
export default {
  mixins: [TabelaErroMixin]
};
</script>

<style lang="scss" scoped>
.body-tabela-erro {
  height: 394px;
}
</style>
